﻿import React, { useState, useEffect } from 'react';
import GlobalDialog from '../Modal/GlobalDialog';
import NoteViewer from '../NoteViewer';
import TaskBuilderComponent from './TaskBuilderComponent';
import { TaskType } from '../../models/DmaTasks/task-type';
import { TaskTypeParameter } from '../../models/DmaTasks/task-type-parameter';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType, NoteType, DataType } from '../../models/enums';
import { LookupItem } from '../../models/lookup-item';
import { ToastProps } from '../../models/toast-props';
import { CrudFunctions } from '../../utilities/crud-functions';
import { ItemBasicInformation } from '../../models/item-basic-information';
import ItemBasicInformationDialog from '../ItemBasicInformationDialog';
import DmaFooter from '../DmaFooter';
import TicketLogEntryForm from '../TicketLogEntryForm';

import DataGrid, {
    Column,
    FilterRow,
    Selection,
    Button as ColumnButton,
    HeaderFilter,
    Toolbar,
    Popup,
    Form,
    Lookup,
    Item as ToolbarItem,
    Editing,
    Paging,
    Pager,
    Scrolling,
    SearchPanel,
    LoadPanel,
    MasterDetail
} from 'devextreme-react/data-grid';

import { Item } from 'devextreme-react/form';
import Button from 'devextreme-react/button';
import Toast from 'devextreme-react/toast';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { SortableListData } from '../../models/Common/sortable-list-data';

let key = 0;

const dataTypes = Object.keys(DataType).filter((key) => isNaN(Number(key))).map(function (dt) { return { id: DataType[dt], name: dt }; });

export default function TasksManagementForm() {
    const [taskTypes, setTaskTypes] =
        useState<TaskType[]>();

    const [selectedTaskType, setSelectedTaskType] =
        useState<TaskType>();

    const [taskTypeParameters, setTaskTypeParameters] =
        useState<TaskTypeParameter[]>();

    const [selectedTaskTypeParameter, setSelectedTaskTypeParameter] =
        useState<TaskTypeParameter>();

    const [taskCategories, setTaskCategories] =
        useState<LookupItem[]>();

    const [taskBuilderComponentDialogVisible, setTaskBuilderComponentDialogVisible] =
        useState<boolean>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [ticketLogEntryDialogVisible, setTicketLogEntryDialogVisible] =
        useState<boolean>();

    const [itemBasicInitInformation, setItemBasicInitInformation] =
        useState<ItemBasicInformation>();

    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        getTaskTypeParameters();
    }, [selectedTaskType]);

    key++;

    return (
        <div className="pw-content">
            <div className="lq-title-bar pw-form-header">
                <div className="lq-main-title">Tasks Management</div>

                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <Button id="goBackButton" text="" icon="arrowleft" type="normal"
                        hint="go back"
                        height={'2.6em'}
                        onClick={goBack} />
                </div>
            </div>

            <div className="pw-60-40-container">
                <div>
                    <div className="pw-margin-top-05">
                        <DataGrid height="24rem"
                            dataSource={taskTypes ? taskTypes : []}
                            wordWrapEnabled={true}
                            allowColumnResizing={true}
                            columnResizingMode='widget'
                            keyExpr="taskTypeId"
                            onSelectionChanged={onTaskTypesSelectionChanged}
                            onRowValidating={onTaskTypesRowValidating}
                            rowAlternationEnabled={true}
                            showRowLines={true}
                            showBorders={true}>

                            <LoadPanel enabled={true} />
                            <Paging defaultPageSize={30} />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={[30, 60, 100]}
                                showInfo={true} />
                            <Selection mode='single' />
                            <HeaderFilter visible={true} />
                            <FilterRow visible={true} />

                            <SearchPanel visible={true} />

                            <Column type="buttons" width="8rem">
                                <ColumnButton name="edit" />
                                <ColumnButton hint="audit information" icon="clock"
                                    onClick={onTaskTypeAuditButtonClicked} />
                                <ColumnButton hint="information" icon="info"
                                    onClick={onTaskTypeInformationButtonClicked} />
                                <ColumnButton name="delete" />
                            </Column>

                            <Column dataField='name' dataType='string' width='12rem' />

                            <Column dataField='categoryId' caption="Category" dataType='number' width='12rem'>
                                <Lookup dataSource={taskCategories ? taskCategories : []}
                                    allowClearing={true}
                                    displayExpr='name' valueExpr='id' />
                            </Column>
                            <Column />

                            <MasterDetail enabled={true} component={subTaskTypesComponent} />
                            <Toolbar>
                                <ToolbarItem location='before'>
                                    <div className="pw-datagrid-toolbar-template">
                                        <div className="pw-datagrid-toobar-title">Task Types</div>
                                    </div>
                                </ToolbarItem>

                                <ToolbarItem location='after' name="searchPanel" />
                                <ToolbarItem location='after' name="addRowButton" />
                            </Toolbar>

                            <Editing mode="popup"
                                useIcons={true}
                                allowAdding={true}
                                allowUpdating={true}
                                allowDeleting={true}>

                                <Popup title="Edit Task" showTitle={true} width="55rem" height="25rem" />
                                <Form>
                                    <Item dataField="name" />
                                    <Item dataField="categoryId" colSpan={2} />
                                </Form>
                            </Editing>

                        </DataGrid>
                    </div>

                    {/* 
                     <div className="pw-margin-top-05">
                        <DataGrid
                            height="16rem"
                            dataSource={taskTypes ? taskTypes : []}
                            wordWrapEnabled={true}
                            allowColumnResizing={true}
                            columnResizingMode='widget'
                            keyExpr="taskTypeId"
                            onSelectionChanged={onTaskTypesSelectionChanged}
                            onRowValidating={onTaskTypesRowValidating}
                            rowAlternationEnabled={true}
                            showRowLines={true}
                            showBorders={true}>

                            <LoadPanel enabled={true} />
                            <Paging defaultPageSize={30} />
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={[30, 60, 100]}
                                showInfo={true} />
                            <Selection mode='single' />
                            <HeaderFilter visible={true} />
                            <FilterRow visible={true} />

                            <SearchPanel visible={true} />

                            <Column type="buttons" width="8rem">
                                <ColumnButton name="edit" />
                                <ColumnButton hint="audit information" icon="clock"
                                    onClick={onTaskTypeAuditButtonClicked} />
                                <ColumnButton hint="information" icon="info"
                                    onClick={onTaskTypeInformationButtonClicked} />
                                <ColumnButton name="delete" />
                            </Column>

                            <Column dataField='name' dataType='string' width='12rem' />
                            <Column dataField='categoryId' caption="Category" dataType='number' width='12rem'>
                                <Lookup dataSource={taskCategories ? taskCategories : []}
                                    allowClearing={true}
                                    displayExpr='name' valueExpr='id' />
                            </Column>
                            <Column />

                            <Toolbar>
                                <ToolbarItem location='before'>
                                    <div className="pw-datagrid-toolbar-template">
                                        <div className="pw-datagrid-toobar-title">Task Types</div>
                                    </div>
                                </ToolbarItem>

                                <ToolbarItem location='after' name="searchPanel" />
                                <ToolbarItem location='after' name="addRowButton" />
                            </Toolbar>

                            <Editing mode="popup"
                                useIcons={true}
                                allowAdding={true}
                                allowUpdating={true}
                                allowDeleting={true}>

                                <Popup title="Edit Task" showTitle={true} width="55rem" height="25rem" />
                                <Form>
                                    <Item dataField="name" />
                                    <Item dataField="categoryId" colSpan={2} />
                                </Form>
                            </Editing>

                        </DataGrid>
                    </div>
                    
                    */}


                    <div className="pw-margin-top-05">
                        <DataGrid
                            height="20rem"
                            dataSource={taskTypeParameters ? taskTypeParameters : []}
                            wordWrapEnabled={true}
                            allowColumnResizing={true}
                            columnResizingMode='widget'
                            keyExpr="taskTypeParameterId"
                            onInitNewRow={onInitNewTaskTypeParameter}
                            onSelectionChanged={onTaskTypeParametersSelectionChanged}
                            onRowValidating={onTaskTypeParametersRowValidating}
                            rowAlternationEnabled={true}
                            showRowLines={true}
                            showBorders={true}>

                            <LoadPanel enabled={true} />
                            <Paging enabled={false} />
                            <Selection mode='single' />

                            <Column type="buttons" width="8rem">
                                <ColumnButton name="edit" />
                                <ColumnButton hint="audit information" icon="clock"
                                    onClick={onTaskTypeParameterAuditButtonClicked} />
                                <ColumnButton hint="information" icon="info"
                                    onClick={onTaskTypeParameterInformationButtonClicked} />
                                <ColumnButton name="delete" />
                            </Column>

                            <Column dataField='name' dataType='string' width='12rem' />
                            <Column dataField='description' dataType='string' />
                            <Column dataField='dataType' dataType='number' width='10rem'>
                                <Lookup dataSource={dataTypes ? dataTypes : []}
                                    displayExpr='name' valueExpr='id' />
                            </Column>

                            <Column dataField='required' dataType='boolean' width='8rem' />

                            <Column />

                            <Toolbar>
                                <ToolbarItem location='before'>
                                    <div className="pw-datagrid-toolbar-template">
                                        <div className="pw-datagrid-toobar-title">Task Parameters</div>
                                    </div>
                                </ToolbarItem>

                                <ToolbarItem location='after' name="addRowButton" />
                            </Toolbar>

                            <Editing mode="popup"
                                useIcons={true}
                                allowAdding={true}
                                allowUpdating={true}
                                allowDeleting={true}>

                                <Popup title="Edit Task Parameter" showTitle={true} width="55rem" height="25rem" />
                                <Form>
                                    <Item dataField="name" />
                                    <Item dataField="description" colSpan={2} />
                                    <Item dataField="dataType" />
                                    <Item dataField="required" />

                                </Form>
                            </Editing>

                        </DataGrid>
                    </div>

                </div>

                <div className="pw-margin-left-1">
                    <div className="">
                        <NoteViewer height='12.6rem' title="Task Type Description" headerColor="pw-bg-gray"
                            noteType={NoteType.TaskTypeDescription}
                            parentId={selectedTaskType && selectedTaskType.taskTypeId ? selectedTaskType.taskTypeId : null} />
                    </div>

                    <div className="">
                        <Button id="showTaskBuilderButton" text="Task Builder" icon="" type="success"
                            hint="go to task builder"
                            height="2.1rem"
                            onClick={showTaskBuilderComponentDialog} />
                    </div>
                </div>

            </div>

            <DmaFooter />


            {taskBuilderComponentDialogVisible &&
                <DialogPopup visible={taskBuilderComponentDialogVisible}
                    onHiding={hideTaskBuilderComponentDialog}
                    title="Task Builder"
                    fullScreen={true} >
                    <TaskBuilderComponent onSubmit={onTaskBuilderSubmit}
                        onCancel={onTaskBuilderCancel} />
                </DialogPopup>
            }

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInitInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {ticketLogEntryDialogVisible &&
                <DialogPopup visible={ticketLogEntryDialogVisible}
                    onHiding={hideTicketLogEntryDialog}
                    title="Ticket Log Entry"
                    width={'55rem'}
                    height={'45rem'}
                    dragEnabled={true}
                    resizeEnabled={true}>
                    <TicketLogEntryForm formName="Task Management Form" contextData={selectedTaskType}
                        onCancel={hideTicketLogEntryDialog}
                        onComplete={hideTicketLogEntryDialog}
                        key={`TLE${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    function onTaskBuilderSubmit(newTaskName: string, data: SortableListData) {
        hideTaskBuilderComponentDialog();
    }

    function onTaskBuilderCancel() {
        hideTaskBuilderComponentDialog();
    }

    function onInitNewTaskTypeParameter(e: any) {
        if (selectedTaskType) {

            let taskTypeParameter: TaskTypeParameter = {
                taskTypeId: selectedTaskType.taskTypeId,
                dataType: DataType.String,
                required: true
            };

            e.data = taskTypeParameter;
        }
    }

    function onTaskTypesSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0)
            setSelectedTaskType(e.selectedRowsData[0]);
    }

    function onTaskTypeParametersSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0)
            setSelectedTaskTypeParameter(e.selectedRowsData[0]);
    }

    async function onTaskTypeParametersRowValidating(e: any) {
        console.log("onTaskTypeParametersRowValidating");
        console.log(e);

        if (e.oldData) {
            let taskTypeParameter = e.oldData as TaskTypeParameter;

            if (taskTypeParameter) {
                let updatedTaskTypeParameter = { ...taskTypeParameter, ...e.newData };

                await updateTaskTypeParameter(updatedTaskTypeParameter)
                    .then(() => {
                        showToast("Task Type Parameter updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Task Type Parameter");
                    });
            }
        }
        else {
            if (e.newData) {
                let taskTypeParameter = e.newData as TaskTypeParameter;

                await insertTaskTypeParameter(taskTypeParameter)
                    .then(() => {
                        showToast("Task Type Parameter saved", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Inserting Task Type Parameter");
                    });
            }
        }
    }

    async function onTaskTypesRowValidating(e: any) {
        if (e.oldData) {
            let taskType = e.oldData as TaskType;

            if (taskType) {
                let updatedTaskType = { ...taskType, ...e.newData };

                await updateTaskType(updatedTaskType)
                    .then(() => {
                        showToast("Task Type updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Task Type");
                    });
            }
        }
        else {
            if (e.newData) {
                let taskType = e.newData as TaskType;

                await insertTaskType(taskType)
                    .then(() => {
                        showToast("Task Type saved", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Inserting Task Type");
                    });
            }
        }
    }

    async function getTaskTypes() {
        await CrudFunctions.getData("dmatasks/tasktypes")
            .then((data) => {

                console.log(data);

                setTaskTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Task Types");
            });
    }

    async function getDataTypes() {
        await CrudFunctions.getData("common/datatypes")
            .then((data) => {
                setTaskTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Task Types");
            });
    }

    async function getTaskTypeParameters() {
        if (selectedTaskType && selectedTaskType.taskTypeId)
            await CrudFunctions.getData(`dmatasks/tasktypeparametersbytasktypeid/${selectedTaskType.taskTypeId}`)
                .then((data) => {
                    setTaskTypeParameters(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Task Type Parameters");
                });
    }

    async function getTaskCategories() {
        await CrudFunctions.getData("common/taskcategories")
            .then((data) => {
                setTaskCategories(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Task Categories");
            });
    }

    async function insertTaskType(taskType: TaskType) {
        return await CrudFunctions.postData("dmatasks/tasktype", taskType);
    }

    async function insertTaskTypeParameter(taskTypeParameter: TaskTypeParameter) {
        return await CrudFunctions.postData("dmatasks/tasktypeparameter", taskTypeParameter);
    }

    async function updateTaskType(taskType: TaskType) {
        return await CrudFunctions.putData("dmatasks/taskType", taskType);
    }

    async function updateTaskTypeParameter(taskTypeParameter: TaskTypeParameter) {
        return await CrudFunctions.putData("dmatasks/tasktypeparameter", taskTypeParameter);
    }

    async function getAllData() {
        await Promise.all([
            getTaskCategories(),
            getTaskTypes()

        ]);
    }

    //navigation
    function goBack() {
        history.back();
    }

    //render

    function subTaskTypesComponent(e: any) {
        console.log("subTaskTypesComponent...");
        console.log(e);

        if (e.data && e.data.data && e.data.data.subTaskTypes && e.data.data.subTaskTypes.length > 0) {
            const subTaskTypes = e.data.data.subTaskTypes as TaskType[];

            return (
                <div className="pw-margin-left-1 pw-margin-bottom-05">
                    <DataGrid
                        dataSource={subTaskTypes}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        columnAutoWidth={true}>
                        <Column dataField='name' dataType='string' width='12rem' />

                        <Column dataField='categoryId' caption="Category" dataType='number' width='12rem'>
                            <Lookup dataSource={taskCategories ? taskCategories : []}
                                allowClearing={true}
                                displayExpr='name' valueExpr='id' />
                        </Column>
                        <Column />
                    </DataGrid>
                </div>
            );
        }
        else
            return (
                <div></div>
            );
    }


    /*
    function renderRevalidationCell(cellData: any) {
        const currentDate = new Date();
        const revalidationDate = cellData.data.nextCalibrationDate;
 
        if (revalidationDate) {
            const daysDifference = PWDates.getDifferenceInDays(currentDate, new Date(revalidationDate))
 
            if (daysDifference >= 30)
                return (<div className="validation-pass">{PWDates.getLocalDateString(revalidationDate)}</div>);
            else if (daysDifference < 30 && daysDifference > 0)
                return (<div className="validation-warn">{PWDates.getLocalDateString(revalidationDate)}</div>);
            else
                return (<div className="validation-fail">{PWDates.getLocalDateString(revalidationDate)}</div>);
        }
        else {
            return (<div className="validation-fail">NA</div>);
        }
    }
    */

    function onTaskTypeAuditButtonClicked(e: any) {


    }

    function onTaskTypeParameterAuditButtonClicked(e: any) {


    }

    //other
    function onTaskTypeInformationButtonClicked(e: any) {

        console.log("onTaskInformationButtonClicked-----------------");
        console.log(e);

        if (e.row && e.row.data) {
            const taskType = e.row.data as TaskType;

            if (taskType) {
                setSelectedTaskType(taskType);

                let itemInformation: ItemBasicInformation = {
                    rowPointer: taskType.taskTypeId,
                    createTimestamp: taskType.createTimestamp,
                    lastModifiedTimestamp: taskType.modifyTimestamp,
                    createUser: taskType.createUser,
                    modifyUser: taskType.modifyUser
                };

                console.log("RESULT:");
                console.log(itemInformation);

                setItemBasicInformation(itemInformation);
                setItemBasicInformationDialogVisible(true);
            }
        }
    }

    function onTaskTypeParameterInformationButtonClicked(e: any) {

    }

    function showTaskBuilderComponentDialog() {
        setTaskBuilderComponentDialogVisible(true);
    }

    function hideTaskBuilderComponentDialog() {
        setTaskBuilderComponentDialogVisible(false);
    }

    function hideTicketLogEntryDialog() {
        setTicketLogEntryDialogVisible(false);
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }


}

